let API_URL = {
    /*global  process:true*/
    /* global API_GATEWAY:true */
     /* global TRACK_VIEWS_API_GATEWAY:true */
    collect: API_GATEWAY?(API_GATEWAY+ '/etl' + '/v1'):(process.env.HOST_NAME + '/etl' + '/v1'),
		collect_v2: API_GATEWAY ? (API_GATEWAY + '/collect' + '/v2') : (process.env.HOST_NAME + '/collect' + '/v2'),
    decryption:API_GATEWAY?(API_GATEWAY+ '/decryption' + '/v1'):(process.env.HOST_NAME + '/decryption' + '/v1'),
	track_event_host: TRACK_VIEWS_API_GATEWAY?TRACK_VIEWS_API_GATEWAY:process.env.TRACK_EVENT_HOST,
};

const Constants = {
    BASE_URL: API_URL.collect,
    BASE_URL_V2: API_URL.collect_v2,
    BASE_URL_DECRYPTION: API_URL.collect,
	TRACKEVENT_BASE_URL: API_URL.track_event_host,
	OSS_FILE_TYPE: {
		"image": 1,
		"video": 2,
		"doc": 4
	},

	OSS_OBJECT_TYPE: {
		'json': 3,
		'richtext': 4,
		// 'exam': 2,
		// 'groundtruth': 1
	},

	USER_ROLE: {
		DS: "1", // 需求方
        PM: "2", // 项目经理
        COLLECTOR: "3", // 项目经理
	},

	PROJECT_USER_SHARE_ROLE: {
		//1： 项目经理 2： 共享
		projectManager: 1,
		share: 2,
	},

	CREATE_PROJECT_TYPE: {
		FORMAL: 1, //正式项目
		COPY_FORMAL: 2, //复制正式项目
		READY: 3, //预立项项目
		READY2FORMAL: 4, //预立项转正式项目
	},

	PROJECT_OPERATION: {
		CREATE: 1, //创建项目
		EDIT: 2, //编辑项目
	},

	SCENE_MODE: {
		TAG_MODE: "1",
		FREE_MODE: "2"
	},

	SHOOT_ARG: {
		SAVE_MODE: {
			IMAGE_SEQUENCE: "1",
			VIDEO: "2",
			IMAGE: "3",
		},
		SHOOT_TYPE: {
			MANUAL: "1", //手动摄像
			AUTO_STOP: "2", //自动停止摄像
			TAKE_PTHOTO: "3", //拍照
		},
		CAMERA_POSITION: {
			FRONT: "1", //前置
			BACK: "2", //后置
		},
	}

}

export default Constants



// WEBPACK FOOTER //
// ./src/js/utils/constants.js